<template>
  <v-card>
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="close_form()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
      <div class="flex-grow-1" />
    </v-toolbar>
    <div v-if="dialog_item.charakteristika.length > 0">
      <v-card>
        <v-card-title>
          <span class="headline">Charakteristika</span>
        </v-card-title>
        <v-card-text
          v-for="(item, index) in dialog_item.charakteristika"
          :key="index"
        >
          {{ item }}
        </v-card-text>
      </v-card>
    </div>
    <div v-if="dialog_item.zdroj.length > 0">
      <v-card>
        <v-card-title>
          <span class="headline">Zdroj</span>
        </v-card-title>
        <v-card-text
          v-for="(item, index) in dialog_item.zdroj"
          :key="index"
        >
          {{ item }}
        </v-card-text>
      </v-card>
    </div>
    <div v-if="dialog_item.priklad.length > 0">
      <v-card>
        <v-card-title>
          <span class="headline">Príklad</span>
        </v-card-title>
        <v-card-text
          v-for="(item, index) in dialog_item.priklad"
          :key="index"
        >
          {{ item }}
        </v-card-text>
      </v-card>
    </div>
    <div v-if="dialog_item.poznamka.length > 0">
      <v-card>
        <v-card-title>
          <span class="headline">Poznámka</span>
        </v-card-title>
        <v-card-text
          v-for="(item, index) in dialog_item.poznamka"
          :key="index"
        >
          {{ item }}
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "TooltipComponent",
  props: {
    dialog_item: { type: Object, required: true },
    on_close: { type: Function, required: false },
  },
  methods: {
    close_form() {
      if (this.on_close != null) {
        this.on_close();
      }
    },
  },
};
</script>>